<template>
	<div class="productFinish-container">
		<div class="wrap">
			<h6>Thank you for your order!</h6>
			<div class="title">
				Details
			</div>
			<div class="content">
				<ul>
					<li>
						<label>SN：</label>
						<div class="rt-">{{order.order_sn}}</div>
					</li>
					<li>
						<label>Time：</label>
						<div class="rt-">{{moment(order.time*1000).format('MMMM DD,YYYY  HH:mm')}}</div>
					</li>
					<li>
						<label>Consignee：</label>
						<div class="rt-">{{order.first_name}} {{order.last_name}}</div>
					</li>
                    <li>
						<label>Email：</label>
						<div class="rt-">{{order.email}}</div>
					</li>
					<li>
						<label>Phone：</label>
						<div class="rt-">{{order.phone}}</div>
					</li>
					<li>
						<label>Address：</label>
						<div class="rt-">{{order.country}}{{order.address}}</div>
					</li>
					<li>
						<label>Postcode：</label>
						<div class="rt-">{{order.postcode}}</div>
					</li>
					<li>
						<label>Payment method：</label>
						<div class="rt-">Paypal</div>
					</li>

				</ul>
			</div>
			<div class="product-container">
				
				<div class="item">
					<div class="img">
						<img :src="order.goods_img" />
					</div>
					<div class="name"> {{order.goods_name}}</div>
					<div class="size">Size：{{order.code}}</div>
					<div class="num">{{order.num}}</div>
					<div class="price">${{order.price}}</div>
				</div>
			</div>
			
			<div class="price-bottom" >
				We will email  you  an order confirmation with details
			</div>
		</div>
	</div>
</template>

<script>
   
	export default {
		name: "we",
		data() {
			return {

               order_id:0,
               order:null
			}
		},
		mounted() {
			
			this.order_id=this.$route.query.sn;
            this.getOrderDetails();
		},
		methods: {
			
            getOrderDetails(){

            	var app = this;

            	this.$api("/user/getOrderDetails",{order_id:this.order_id}).then(function(res) {

                       app.order  = res.data;

                       console.log(app.order)
                      
				})
            }


		}

	}
</script>


<style lang="less">

	.productFinish-container {
		margin-top:150px;
		margin-bottom:50px;
		.wrap {
			width: 900px;
			margin: 0 auto;	
			.price-bottom {
				padding: 40px;
				font-size: 16px;
				margin: 50px 0;
				font-weight:bold;
				background-color: #f7f8f8;
			}
			.product-container{
				.item{
					padding: 30px 0;
					display: flex;
					align-items: center;
					border: 1px solid #dcdddd;
					>div{
						flex:1;
						line-height: 1.6;
						text-align: center;
					}
					.img{
						flex:  0 0 140px;
						img{
							width: 140px;
						}
					}
					.name{
						font-size: 16px;
						flex:  0 0 200px;
						padding: 0 10px;
						padding-left:40px;
						text-align:left;
						color: #0f0e0e;
					}
					.size{
						color: #999999;
						font-size: 14px;
					}
					.num{
						color: #999999;
						font-size: 14px;
					}
					.pirce{
						font-size: 16px;
						color: #0f0e0e;
					}
					
					
				}
				.title{
					padding: 20px 0;
					background-color: #f7f8f8;
					display: flex;
				    color: #666666;
					font-size: 16px;
					>div{
						padding: 0 30px;
						text-align:center;
						flex: 1;
						
						&:first-child{
							text-align: left;
							box-sizing: border-box;
							flex:  0 0 360px;
						}
					}
				}
			}
			h6 {
				font-size: 20px;
				font-weight: bold;
				padding-bottom: 20px;

			}
			> .title {
				border-top: 4px solid #90c31f;
				line-height: 55px;
				color: #666;
				background-color: #f7f8f8;
				font-size: 16px;
				padding-left: 20px;
			}

			.content {
				font-size: 16px;
				padding: 40px 0;
				ul{
					li{
						overflow: hidden;
						line-height: 1.6;
						color: #666666;
						margin-bottom: 20px;
						.rt-{
							color:#999999;
						}
						label{
							width: 120px;
							float: left;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width:768px) {
		.productFinish-container{
			margin-top:50px;
			margin-bottom:4%;
			.wrap{
				padding:4%;
				max-width:92%;
				.product-container{
	                .item{
	                    display:block;
	                    >div{
	                    	padding: 10px;
	                    	text-align:left;
	                    	display:inline-block;
	                    	font-size:14px;
	                    }
	                    .name{
	                    	padding-left:10px;
	                    	font-size:14px;
	                    }
	 				}
				}
				> .title{
					line-height: 40px;
					font-size:14px;
					padding-left:10px;
				}
				h6{
					font-size:16px;
					padding-bottom:10px;
				}
				.price-bottom{
					margin:20px 0;
					padding:20px;
				}
				.content{
					padding:20px 0;
					font-size: 14px;
					ul{
						li{
                            margin-bottom:10px;
							label{
								width: 100px;
								float: left;
							}
						}
					}
				}


			}

		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/product/productFinish.vue